const configuration = {
    current: [],
};
const parse = (urlToScreen) => {
    return Object.entries(urlToScreen).map(([pattern, name]) => {
        if (pattern.charAt(pattern.length - 1) === '*') {
            const prefix = pattern.substr(0, pattern.length - 1);
            return {
                test: (url) => url.indexOf(prefix) === 0,
                name,
            };
        }
        return {
            test: (url) => url === pattern,
            name,
        };
    });
};
const config = (urlToScreen) => {
    configuration.current = parse(urlToScreen);
};
const reset = () => {
    configuration.current = [];
};
const match = (url, parsedUrlToScreens) => {
    const matchers = parsedUrlToScreens || configuration.current;
    for (let i = 0; i < matchers.length; i += 1) {
        const matcher = matchers[i];
        if (matcher.test(url)) {
            return matcher.name;
        }
    }
    return undefined;
};
export default {
    parse,
    config,
    reset,
    match,
};
